import React from 'react'
import Radium from 'radium'
import {
  BrowserRouter as Router,
} from 'react-router-dom'
import { Formik } from 'formik'

import Width from './Width'
import Form from './Form/index'
import BudgetReview from './BudgetReview/index'
import initialValues from './lib/initialValues'

export default Radium(() => (
  <Router>
    <Formik
      initialValues={initialValues}
    >
      {(form) => (
        <Width>
          {({ isMedium, isSmall }) => (
            <div
              style={[
                styles.container,
                isMedium && styles.medium.container,
                isSmall && styles.small.container,
              ]}
            >
              <Form form={form} />
              <BudgetReview form={form} />
            </div>
          )}
        </Width>
      )}
    </Formik>
  </Router>
))

const styles = {
  container: {
    display: 'flex',
    padding: '50px 20px',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  medium: {
    container: {
      flexDirection: 'column',
      maxWidth: '768px',
      margin: '0 auto',
    },
  },
  small: {
    container: {
      padding: '50px 10px',
    },
  },
}
